<template>
  <div id="app">
    <AppHeader />
    <router-view />
    <AppFooter />
  </div>
</template>

<script>
// @ is an alias to /src
import AppHeader from "@/components/global/app-header.vue";
import AppFooter from "@/components/global/app-footer.vue";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
  },
};
</script>

<style lang="scss">
// #317EAC Blue
// #5E5E5E Gray
// #fa9f1b Orange
// #DA0000 Error Red
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #5e5e5e;
}

// Basic App Centering
.app-center {
  max-width: 1200px;
  min-width: 1200px;
  width: 1200px;
  margin: 0 auto;
}
.app-width {
  min-width: 1200px;
}

// Basic Typography
p {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;

  &.bold, span.bold {
    font-weight: 600;
  }

  &.italic, span.italic {
    font-style: italic;
  }

  &.indent,
  span.indent {
    padding-left: 32px;
  }

  &.knuvu-title {
    font-size: 32px;
    line-height: 38px;
    color: #49a9dc;
    font-weight: 800;
  }

  &.knuvu-subtitle {
    font-size: 20px;
    line-height: 24px;
    color: #242424;
    font-weight: 800;

    &.blue {
      color: #49a9dc;
    }
  }
}

ul {
  li {
    list-style-type: disc;
    margin-left: 32px;
    line-height: 22px;
  }
}

a:link,
a:visited,
a:link:active,
a:visited:active {
  color: #317eac;
  text-decoration: none;
  cursor: auto;
  transition: color 0.2s;

  &:hover {
    color: #4694c2;
    cursor: pointer;
  }
}

// Flex Helpers
.f-flex {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.f-inline-flex {
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-align-content: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
}
.f-row {
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}
.f-nowrap {
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.f-justify-start {
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.f-justify-space-betwen {
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-align-content: space-between;
  -ms-flex-line-pack: justify;
  align-content: space-between;
}
.f-flex-start {
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

// Basic Reset
html {
  box-sizing: border-box;
  font-size: 16px;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ol,
ul {
  margin: 0;
  padding: 0;
  font-weight: normal;
}
ol,
ul {
  list-style: none;
}
img {
  max-width: 100%;
  height: auto;
}

// Tooltip Styles
.tooltip {
  display: block !important;
  z-index: 10000;
  max-width: 300px;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 10px 16px;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>
